// The owner-scope switcher moved to the left nav (PAN-425) so it is visible on every page.
export const DashboardHeader = ({
  revenueUnit,
  onRevenueUnitChange,
  disabled = false,
}) => (
  <div className="mb-7 flex items-start justify-between">
    <div>
      <h1 className="m-0 text-[22px] font-extrabold leading-tight tracking-tight text-slate-800">
        Panora Dashboard
      </h1>
      <p className="mb-0 mt-1 text-[13px] font-medium text-slate-400">
        Your strategic revenue focus — what to protect, renew, and grow
      </p>
    </div>
    <div
      className="relative grid grid-cols-2 rounded-lg border border-slate-200 bg-white p-1 shadow-sm"
      role="group"
      aria-label="Revenue unit"
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute inset-y-1 left-1 w-[calc(50%-0.25rem)] rounded-md bg-slate-800 shadow-sm transition-transform duration-200 ease-out motion-reduce:transition-none ${
          revenueUnit === "ARR" ? "translate-x-full" : "translate-x-0"
        }`}
      />
      {["MRR", "ARR"].map((unit) => (
        <button
          key={unit}
          type="button"
          aria-pressed={revenueUnit === unit}
          disabled={disabled}
          onClick={() => onRevenueUnitChange(unit)}
          className={`relative z-10 cursor-pointer rounded-md px-3 py-1.5 text-xs font-bold transition-colors duration-200 ${
            revenueUnit === unit
              ? "text-white"
              : "text-slate-500 hover:text-slate-700"
          } disabled:cursor-not-allowed disabled:opacity-50`}
        >
          {unit}
        </button>
      ))}
    </div>
  </div>
);
